export default new Error('MdSinapsePrescricao was not initialized.')
